import { Switch } from "react-router-dom";
import GrupoUnidadeListagem from "./Listagem";
import VerGrupoPage from "./VerGrupo";
import AuthRoute from "components/AuthRoute";
import { PermissaoEnum } from "resources/enums/permissao";

function GrupoUnidadePages() {
  return (
    <Switch>
      <AuthRoute
        path="/cadastros/grupos-unidades"
        component={GrupoUnidadeListagem}
        exact
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.GrupoUnidade.Visualizar,
        ]}
      />
      <AuthRoute
        path="/cadastros/grupos-unidades/:id"
        component={VerGrupoPage}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.GrupoUnidade.Editar,
        ]}
      />
    </Switch>
  );
}

export default GrupoUnidadePages;
